/*
DO NOT MANUALLY TRANSLATE!
Follow the instructions in the README.md to conveniently update translations.
*/

export default {
  "CookieMessage.old.link": "Подробнее",
  "CookieMessage.old.text":
    "Для улучшения работы нашего интернет-магазина мы используем файлы cookie. Ознакомьтесь с нашей политикой использования cookie.",
  "CookieMessage.link": "Cookies принятия",
  "CookieMessage.more_information":
    "Узнайте больше об использовании файлов cookie в Kramp",
  "CookieMessage.return": "Назад",
  "CookieMessage.intro.body":
    "Файлы cookie размещены самой компанией {0} и третьими лицами. Разумеется, мы строго соблюдаем конфиденциальность ваших данных. Нажимая кнопку «Принять cookies» ниже, вы даете согласие на использование файлов cookie. Соглашаясь с использованием файлов cookie, вы гарантируете корректную работу нашего веб-сайта. Вот несколько примеров того, для чего используются файлы cookie:",
  "CookieMessage.intro.list.1": "автоматический вход в учетную запись;",
  "CookieMessage.intro.list.2":
    "анализ поведения пользователей для улучшения веб-сайта;",
  "CookieMessage.intro.list.3":
    "создание профилей клиентов, позволяющих показывать вам персонализированные предложения и рекламные объявления.",
  "CookieMessage.intro.extra":
    'Если вы не согласны с использованием файлов cookie, вы можете изменить соответствующие <a>настройки</a>. Для получения дополнительной информации ознакомьтесь с <a href="{legalLink}">Положением о конфиденциальности и использовании файлов cookie</a>.',
  "CookieMessage.intro.title": "Компания Kramp использует файлы cookie",
  "CookieMessage.settings.body":
    "Вы можете выбрать одну из трех настроек cookie. Максимально комфортная работа с веб-сайтом гарантируется при выборе стандартной полной настройки.",
  "CookieMessage.settings.standard.title":
    "Стандартный объем (самая популярная настройка):",
  "CookieMessage.settings.standard.body":
    "файлы cookie, используемые для входа в систему, размещения заказов, анализа, показа персонализированных предложений и связи с социальными сетями, а также файлы cookie сторонних сайтов как внутри, так и за пределами Европы.",
  "CookieMessage.settings.restricted.title": "Ограниченный объем:",
  "CookieMessage.settings.restricted.body":
    "файлы cookie, используемые для входа в систему, размещения заказов, анализа и показа персонализированных предложений.",
  "CookieMessage.settings.highly_restricted.title":
    "Строго ограниченный объем:",
  "CookieMessage.settings.highly_restricted.body":
    "вы разрешаете сохранять только минимальное количество файлов cookie, используемых для входа в систему, размещения заказов и обеспечения базовой функциональности веб-сайта.",
  "CookieMessage.settings.options.title": "Вот что мы делаем:",
  "CookieMessage.settings.option.1":
    "Используем файлы cookie для обеспечения корректной работы данного веб-сайта",
  "CookieMessage.settings.option.2": "Анализируем поведение пользователей",
  "CookieMessage.settings.option.3": "Собираем персональную статистку",
  "CookieMessage.settings.option.4":
    "Показываем информацию, отвечающую интересам пользователей",
  "CookieMessage.settings.option.5":
    "Используем информацию для наших рекламных объявлений",
  "CookieMessage.settings.option.6": "Собираем анонимную статистику",
  "CookieMessage.settings.option.7": "Делимся вашими персональными данными",
  "CookieMessage.settings.title": "Настройки cookie",
  "CookiePage.url": "politika-o-konfidencialnosti-i-ispolzovanii-cookie-failov",
};
